import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ViewBankAccountReport.css';

const ViewBankAccountReport = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const account = location.state?.account;

    const BASE_URL = "https://payyug.in/";

    if (!account) {
        return (
            <div className="view-bank-error">
                <h3>No Account Data Found</h3>
                <button onClick={() => navigate(-1)}>Back to Reports</button>
            </div>
        );
    }

    return (
        <div className="view-bank-container">
            <div className="view-bank-card">
                {/* Header with Back Button */}
                <div className="view-bank-header">
                    <button className="view-bank-account-back-link" onClick={() => navigate(-1)}>← Back</button>
                    <span className={`view-bank-account-status-badge ${(account.status || 'pending').toLowerCase()}`}>
                        {account.status || 'Pending'}
                    </span>
                </div>

                {/* Profile Header Section */}
                <div className="view-bank-account-profile-main-section">
                    <img 
                        src={account.profilePicture ? `${BASE_URL}${account.profilePicture}` : '/default-avatar.png'} 
                        alt="Profile" 
                        className="large-profile-pic"
                    />
                    <div className="profile-info">
                        <h1>{account.firstName} {account.lastName}</h1>
                        <p className="app-id">Application ID: #SAV-{account.id}</p>
                        <p className="min-bal">Minimum Balance: ₹{account.minimumBalance}</p>
                    </div>
                </div>

                <div className="details-grid">
                    {/* Column 1: Personal Details */}
                    <div className="info-column">
                        <h3>Personal Details</h3>
                        <div className="detail-row"><span>Father's Name:</span> <strong>{account.fatherName || 'N/A'}</strong></div>
                        <div className="detail-row"><span>Date of Birth:</span> <strong>{account.dob || 'N/A'}</strong></div>
                        <div className="detail-row"><span>Mobile:</span> <strong>{account.mobile}</strong></div>
                        <div className="detail-row"><span>Email:</span> <strong>{account.email || 'N/A'}</strong></div>
                        <div className="detail-row"><span>Address:</span> <strong>{account.address || 'N/A'}</strong></div>
                    </div>

                    {/* Column 2: KYC Information */}
                    <div className="info-column">
                        <h3>KYC Information</h3>
                        <div className="detail-row"><span>Aadhaar Number:</span> <strong>{account.aadhaarNumber}</strong></div>
                        <div className="detail-row"><span>PAN Number:</span> <strong>{account.panNumber}</strong></div>
                        <div className="detail-row"><span>Referral ID:</span> <strong>{account.referralId || 'Direct'}</strong></div>
                        <div className="detail-row"><span>Applied On:</span> <strong>{new Date(account.createdAt).toLocaleDateString("en-IN")}</strong></div>
                    </div>
                </div>

                {/* Document Gallery Section */}
                <div className="document-gallery">
                    <h3>KYC Documents</h3>
                    <div className="doc-grid">
                        <div className="doc-box">
                            <p>Aadhaar Front</p>
                            <img src={`${BASE_URL}${account.aadhaarFrontPath}`} alt="Aadhaar Front" onClick={() => window.open(`${BASE_URL}${account.aadhaarFrontPath}`)}/>
                        </div>
                        <div className="doc-box">
                            <p>Aadhaar Back</p>
                            <img src={`${BASE_URL}${account.aadhaarBackPath}`} alt="Aadhaar Back" onClick={() => window.open(`${BASE_URL}${account.aadhaarBackPath}`)}/>
                        </div>
                        <div className="doc-box">
                            <p>PAN Card</p>
                            <img src={`${BASE_URL}${account.panFrontPath}`} alt="PAN Front" onClick={() => window.open(`${BASE_URL}${account.panFrontPath}`)}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewBankAccountReport;


